import { useState, useEffect } from "react";
import { Checkbox } from "./_Checkbox";

export function Period({ years, quarters, selectedYear, selectedQuarter, setSelectedYear, setSelectedQuarter, uncheck }) {
    const [currentYear, setCurrentYear] = useState(selectedYear.id);

    return (
        <fieldset className="period">
            <span className="title">
                <i className="icon"></i>
                {periodTxt}
            </span>
            <select id="yearFilter" className="year" onChange={(e) => setSelectedYear([parseInt(e.target.value)])}>
                <option value="">{allYearsTxt}</option>
                {years.map((year) => (
                    <option key={year.term_id} value={year.term_id} selected={currentYear === year.term_id}>
                        {year.slug}
                    </option>
                ))}
            </select>
            <nav className="quarters">
                <div className="individual">
                    {quarters.map((quarter) => (
                        <label key={quarter.term_id} className="quarter">
                            <Checkbox value={quarter.term_id} selectedCategory={selectedQuarter} setSelectedCategory={setSelectedQuarter} uncheck={uncheck} />
                            {quarter.name}
                        </label>
                    ))}
                </div>
            </nav>
        </fieldset>
    );
}
